interface TimeframesTabProps {
  fiscalYears: any[];
  onAdd: () => void;
  onEdit: (fiscalYear: any) => void;
}

export function TimeframesTab({ fiscalYears, onAdd, onEdit }: TimeframesTabProps) {
  return (
    <div className="max-w-2xl">
      <div className="flex items-center justify-between mb-3">
        <h2 className="text-base font-semibold text-text-primary">Timeframes</h2>
        <button onClick={onAdd} className="px-3 py-1.5 bg-blue-600 text-white text-sm font-medium rounded-md hover:bg-blue-700">
          + Add timeframe
        </button>
      </div>
      <div className="border border-border-default rounded-md overflow-hidden">
        <table className="w-full border-collapse">
          <thead className="bg-background-secondary">
            <tr className="border-b border-gray-200">
              <th className="text-left py-2 px-4 text-xs font-semibold text-text-secondary whitespace-nowrap">Timeframe</th>
              <th className="text-left py-2 px-4 text-xs font-semibold text-text-secondary">Periods</th>
              <th className="text-right py-2 px-4 text-xs font-semibold text-text-secondary">Actions</th>
            </tr>
          </thead>
          <tbody>
            {fiscalYears.map((fy) => (
              <tr key={fy.id} className="border-b border-gray-100 last:border-0 hover:bg-surface-hover">
                <td className="py-2 px-4 text-sm text-text-primary font-medium">{fy.label}</td>
                <td className="py-2 px-4">
                  <div className="flex flex-wrap gap-1">
                    {fy.quarters?.map((q: any) => (
                      <span key={q.id} className="px-1.5 py-0.5 bg-surface-subtle rounded text-xs text-text-secondary">
                        {q.label}
                      </span>
                    ))}
                  </div>
                </td>
                <td className="py-2 px-4 text-right">
                  <button onClick={() => onEdit(fy)} className="text-xs text-blue-600 hover:text-blue-700 font-medium">View</button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        {fiscalYears.length === 0 && (
          <p className="py-6 text-center text-sm text-text-secondary">No timeframes yet.</p>
        )}
      </div>
    </div>
  );
}
